package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_08_11_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have fought their way into an ambush from Goblinoids and Venom Trolls. The casters have finally caught up with the bloodthirsty melee and tides are beginning to turn in our heroes’ favor.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper rushes to the badly wounded Goram, and casts lay on hands, nimbly avoiding combat range with a nearby venom troll.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A heavily wounded hobgoblin flies into the air, attempting to escape.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram strikes the venom troll with a menacing attack, grapples the Devastator, and wounds it badly. Bigglesworth climbs up the hill as if it were flat ground, and he finishes off the grappled Devastator.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("One of the hobgoblins is trampled by a lumbering venom troll trying to escape. Another venom troll attempts to run around the wall of fire. Although there is a small space to the north between the cliffs edge and the wall of fire, it is too small for a troll, so as the troll squeezes into that space, he takes more fire damage.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A hobgoblin climbs up a rock to get a clean shot over the wall of fire, and kills one of Tuesday’s mirror images.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The venom troll which Goram intimidated with his menacing attack is still shaken by the experience. His attacks are poorly timed and aimed at Caper, causing multiple misses. Unfortunately he does eventually connect, dealing serious damage.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Dirk casts grease on the venom troll attempting the northern wall maneuver, knocking him over and burning him.  Tuesday flies over the wall and vaporizes this troll, a fleeing troll, and a couple of goblins.  A Devastator injured by Tuesday’s attack loses his concentration on the difficult task of flying and falls out of the air.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper strikes and kills a hobgoblin and disengages from the venom troll.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram chases the fleeing Devastator, climbs up a rock, and fires a long shot arrow, killing the flying Devastator.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth attacks a troll but the strike spews acid onto his attacker.  Bigglesworth, undeterred by the acid risk, strikes again. The attacks seem to sufficient to kill such a beast, but it seems to regenerate — unlike the previously killed venom trolls who were on fire.  Falorn heals in combat. Dirk and Tuesday target the remaining venom trolls with fire attacks, and Caper helps finish off the remaining flaming venom troll.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Now that combat is over, our heroes inspect their surroundings further.  The doors and ruins are old dwarven architecture from before the Malusian Darkway’s construction.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("On the Warlord’s body the heroes find an ornate key.  They head back into the cave and check out the unexplored south east path.  In a small room they find a chest.  Annette creates a perfect tool to disarm the chest, and then Caper unlocks it using the ornate key. At the bottom of the chest is a contract for an assassination targeting Annette from the Black Mask.")
    }
}
